module.exports = __webpack_public_path__ + "img/ar.1c79a174.svg";